<template>
  <div>
    <b-card>
      <ValidationObserver ref="form">
        <b-row>
          <b-col cols="12" md="6" lg="4">
            <ek-input-text
              :rules="[{ type: 'required', message: 'الاسم و الكنية مطلوب' }]"
              name="name"
              placeholder="أدخل الاسم و الكنية "
              label="الاسم و الكنية"
              v-model="userDto.name"
            ></ek-input-text>
          </b-col>

          <b-col cols="12" md="6" lg="4">
            <ek-input-text
              :rules="[{ type: 'required', message: 'الاسم و الكنية مطلوب' }]"
              name="name"
              placeholder="أدخل   السمتخدم "
              label=" اسم المستخدم "
              v-model="userDto.userName"
            ></ek-input-text>
          </b-col>

          <b-col cols="12" md="6" lg="4">
            <ek-input-text
              :rules="[
                { type: 'required', message: 'البريد الالكتروني مطلوب' },
                { type: 'email', message: 'يرجى ادخال بريد الكتروني صحيح' },
              ]"
              name="email"
              placeholder="ادخل البريد الالكتروني"
              label="البريد الالكتروني"
              v-model="userDto.email"
            ></ek-input-text>
          </b-col>

          <b-col cols="12" md="6" lg="4">
            <ek-input-text
              :rules="[
                { type: 'required', message: 'كلمة المرور مطلوبة' },
                {
                  type: 'min:8',
                  message: 'كلمة المرور يجب ان تحوي 8 محارف على الاقل',
                },
              ]"
              name="password"
              placeholder="أدخل  كلمة السر"
              label="كلمة السر"
              v-model="userDto.password"
            ></ek-input-text>
          </b-col>

          <b-col cols="12" md="6" lg="4">
            <ek-input-text
              :rules="[
                { type: 'required', message: 'رقم الموبايل مطلوب' },
                { type: 'mobile', message: 'رقم الموبايل غير صالح' },
              ]"
              name="phone"
              placeholder="ادخل رقم الموبايل"
              label=" رقم الموبايل"
              v-model="userDto.phoneNumber"
            ></ek-input-text>
          </b-col>

          <b-col cols="12" md="6" lg="4">
            <ek-input-text
              readonly
              name="تاريخ الاشتراك"
              placeholder=" ادخل تاريخ الاشتراك "
              label="تاريخ الاشتراك"
              :value="formDate(userDto.dateCreated)"
            ></ek-input-text>
          </b-col>
        </b-row>
      </ValidationObserver>
      <template #footer>
        <div class="w-100 d-flex justify-content-between">
          <div>
            <b-button
              variant="outline-danger"
              class="mx-1"
              @click="deleteUser(userDto.id)"
            >
              حذف</b-button
            >
          </div>
          <div>
            <b-button variant="primary" @click="submit">تعديل</b-button>
            <b-button variant="outline-primary " class="mx-1" to="/admin/user"
              >تراجع</b-button
            >
          </div>
        </div>
      </template>
    </b-card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  components: {},
  props: {
    id: String,
  },
  computed: {
    ...mapState({
      userDto: (state) => state.user.userDto,
    }),
  },
  methods: {
    ...mapActions(["getByIdUser", "updateUser", "deleteUser"]),
    formDate(dateCreated) {
      let date = `${new Date(dateCreated).toLocaleDateString()}`;
      return date;
    },
    submit() {
      this.$refs["form"].validate().then((suc) => {
        if (suc) {
          this.updateUser({
            id: this.userDto.id,
            name: this.userDto.name,
            email: this.userDto.email,
            userName: this.userDto.userName,
            phoneNumber: this.userDto.phoneNumber,
            password: this.userDto.password,
          });
        }
      });
    },
  },
  created() {
    this.getByIdUser(this.id);
  },
};
</script>

